<div class="container">
  <svg width="100%" height="380"
       viewBox="0 0 560 528"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <rect class="color" x="66" width="432" height="58" rx="4" fill="#EEEEEE"/>
    <rect class="color" y="103" width="560" height="121" rx="8" fill="#EEEEEE"/>
    <rect class="color" y="255" width="560" height="121" rx="8" fill="#EEEEEE"/>
    <!--    <rect class="color" y="407" width="560" height="121" rx="8" fill="#EEEEEE"/>-->
  </svg>
</div>
